import React from 'react';

function ProjectsIcon(props) {
    return (
        
           <i class="fa-solid fa-pager"></i> 
        
    );
}

export default ProjectsIcon;